import { useState, useCallback } from 'react';
import { Channel } from '@/types';

export function useChannel() {
  const [selectedChannel, setSelectedChannel] = useState<Channel>('RETAIL');

  const switchChannel = useCallback((channel: Channel) => {
    setSelectedChannel(channel);
  }, []);

  return {
    selectedChannel,
    switchChannel,
  };
}

export function getChannelDisplayName(channel: Channel): string {
  return channel === 'RETAIL' ? 'AFN Retail' : 'SuperLoans';
}

export function getChannelBrandColor(channel: Channel): string {
  return channel === 'RETAIL' ? 'text-blue-400' : 'text-teal-400';
}